import { jwtDecode } from "jwt-decode";
import getRole from "./RoleService";

const uri = `${import.meta.env.VITE_BASE_URL}/api/notification-event`;

const GetAllAdminPost = async (
  createdAtFrom,
  createdAtTo,
  dateRelease,
  page,
  num_row
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const queryData = new URLSearchParams({
        createdAtFrom: createdAtFrom,
        createdAtTo: createdAtTo,
        dateRelease: dateRelease,
        page: page,
        active: 1,
        num_row: num_row,
      });
      const response = await fetch(`${uri}/get-all?${queryData}`, {
        method: "get",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

const GetAdminPostById = async (id) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const response = await fetch(`${uri}/get/${id}/`, {
        method: "get",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

const GetTodayPost = async () => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const response = await fetch(`${uri}/get-release-today`, {
        method: "get",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

const CreateAdminPost = async (title, content, timeRelease, image64) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const formData = new FormData();
      formData.append("title", title);
      formData.append("content", content);
      formData.append("timeRelease", timeRelease);
      formData.append("image64", image64);
      formData.append("image64", image64);
      const response = await fetch(`${uri}`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

const UpdatePropAdminPost = async (
  id,
  title,
  content,
  timeRelease,
  active,
  isShown
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const formData = new FormData();
      formData.append("id", id);
      formData.append("title", title);
      formData.append("content", content);
      formData.append("timeRelease", timeRelease);
      formData.append("active", active);
      formData.append("isShown", isShown);
      const response = await fetch(`${uri}/update`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

const UpdatePostImages = async (
  id,
  typeAction,
  image64Add,
  imageLinkRemove
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const formData = new FormData();
      formData.append("id", id);
      formData.append("typeAction", typeAction);
      formData.append("image64Add", image64Add);
      formData.append("imageLinkRemove", imageLinkRemove);
      const response = await fetch(`${uri}/update-link`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

export {
  GetAdminPostById,
  GetAllAdminPost,
  GetTodayPost,
  CreateAdminPost,
  UpdatePostImages,
  UpdatePropAdminPost,
};
